var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping2({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#132E47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.67831 9.05045C11.3267 7.0885 13.6631 6.1001 15.9968 6.1001C18.3302 6.1001 20.6568 7.07828 22.3156 9.0508C25.1805 12.4571 24.7357 17.4829 21.6543 20.5754L21.6532 20.5765C19.9046 22.3251 17.8924 24.4505 17.0482 25.3422C16.9906 25.403 16.9385 25.458 16.8922 25.5069C16.407 26.0245 15.5866 26.0245 15.1014 25.5069C15.0551 25.4581 15.003 25.403 14.9454 25.3422C14.1012 24.4505 12.089 22.3251 10.3404 20.5765L10.3392 20.5754C7.25862 17.4836 6.81228 12.4476 9.67831 9.05045ZM15.9968 7.9001C14.1708 7.9001 12.3474 8.67144 11.0559 10.209L11.0546 10.2105C8.84153 12.8331 9.13515 16.8162 11.6138 19.3043C13.2221 20.9126 15.0464 22.8315 15.9968 23.8346C16.9472 22.8315 18.7715 20.9126 20.3798 19.3043C22.8579 16.8168 23.1529 12.8429 20.938 10.2094C19.6367 8.66196 17.8233 7.9001 15.9968 7.9001ZM15.9968 13.3601C15.4538 13.3601 15.0168 13.7972 15.0168 14.3401C15.0168 14.883 15.4538 15.3201 15.9968 15.3201C16.5397 15.3201 16.9768 14.883 16.9768 14.3401C16.9768 13.7972 16.5397 13.3601 15.9968 13.3601ZM13.2168 14.3401C13.2168 12.803 14.4597 11.5601 15.9968 11.5601C17.5338 11.5601 18.7768 12.803 18.7768 14.3401C18.7768 15.8772 17.5338 17.1201 15.9968 17.1201C14.4597 17.1201 13.2168 15.8772 13.2168 14.3401Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping2);
export default __webpack_public_path__ + "static/media/shipping2.ebc330e7746e4202fffb6e6e51e59d4a.svg";
export { ForwardRef as ReactComponent };